module.exports = __webpack_public_path__ + "img/pr-3.43a174dc.png";